import React from 'react'

/**
 * 미니멀 대한민국 정부 상징 (Government Seal)
 */
export function KoreaGovSymbol({ className = 'w-5 h-5' }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="46" fill="#000000" fillOpacity="0.2" stroke="currentColor" strokeWidth="1.5" strokeOpacity="0.2"/>
      <path
        d="M50 14 C 30.12 14 14 30.12 14 50 C 14 59.94 22.06 68 32 68 C 41.94 68 50 59.94 50 50 C 50 40.06 58.06 32 68 32 C 77.94 32 86 40.06 86 50 C 86 30.12 69.88 14 50 14 Z"
        fill="#CD2E3A"
      />
      <path
        d="M50 86 C 69.88 86 86 69.88 86 50 C 86 40.06 77.94 32 68 32 C 58.06 32 50 40.06 50 50 C 50 59.94 41.94 68 32 68 C 22.06 68 14 59.94 14 50 C 14 69.88 30.12 86 50 86 Z"
        fill="#0F4C81"
      />
    </svg>
  )
}

/**
 * 정갈한 미니멀 부처 뱃지 (Linear / Stripe Style)
 */
export function GovMinistryLogo({
  ministryName,
  subText = '대한민국 정부',
  className = '',
}: {
  ministryName: string
  subText?: string
  className?: string
}) {
  return (
    <div className={`inline-flex items-center gap-2.5 px-3 py-1.5 rounded-lg bg-white/[0.04] border border-white/10 ${className}`}>
      <KoreaGovSymbol className="w-4 h-4 shrink-0" />
      <span className="text-[11px] font-mono text-zinc-400 tracking-wider">
        {subText}
      </span>
      <span className="text-zinc-600 text-xs">|</span>
      <span className="text-xs font-semibold text-zinc-200">
        {ministryName}
      </span>
    </div>
  )
}
